import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { PrimeNGInputDropdownComponent } from '@ntap/primeng';
import { TreeNode } from 'primeng/api';
import { RokoviCuvanjaService } from './services/rokovi-cuvanja.service';
import { ItemViewProviderDirective } from '@ntap/core';
import { first, tap } from 'rxjs';

interface Item {
  [key: string]: any;
}

@Component({
  selector: 'app-hierarchy-inputdropdown',
  templateUrl: './hierarchy-dropdown.component.html'
})
export class HierarchyDropdownComponent
  extends PrimeNGInputDropdownComponent
  implements OnDestroy, OnInit
{
  rokoviCuvanjaService = inject(RokoviCuvanjaService);
  private itemViewProvider = inject(ItemViewProviderDirective);
  selectedNodes: any;
  treeData: TreeNode[] = [];

  override ngOnInit() {
    this.rokoviCuvanjaService.getRetentionPeriods().subscribe({
      next: (nodes) => {
        this.itemViewProvider.item$
          .pipe(
            first(),
            tap((item: Item) => {
              this.treeData = this.deleteNode(
                nodes,
                item['sif~poseban_popis_gradiva_s_rokovima_cuvanja~id']
              );
            })
          )
          .subscribe();
        this.selectedNodes = this.findNodesInTree(
          this.treeData,
          this.formControl.value
        );
      },
      error: (err) => console.error('Error fetching retention periods:', err)
    });
  }
  onNodeSelect(event: any) {
    //SET formControl VALUE ON TREESELECT COMPONENT CHANGE
    this.setValue(event.node.data);
    if (event.node.data == '0') {
      this.setValue(null);
    }
  }

  clearSelection() {
    this.selectedNodes = null;
    this.formControl.setValue(null);
    this.formControl.markAsDirty();
  }

  findNodesInTree(tree: TreeNode[], data: any): TreeNode | null {
    for (const node of tree) {
      if (node.data === data) {
        return node;
      }
      if (node.children) {
        const found = this.findNodesInTree(node.children, data);
        if (found) {
          return found;
        }
      }
    }
    return null;
  }
  deleteNode(tree: TreeNode[], valueToDelete: any): TreeNode[] {
    return tree.filter((node) => {
      if (node.data === valueToDelete) {
        return false; // Uklanja trenutni čvor
      }
      if (node.children) {
        node.children = this.deleteNode(node.children, valueToDelete); // Rekurzivno filtriraj djecu
      }
      return true;
    });
  }
}
